export default __webpack_public_path__ + "static/media/no-dashboards.6e0ed4a2.svg";